import { render, staticRenderFns } from "./AutocompleteBasic.vue?vue&type=template&id=a6c666fe"
import script from "./AutocompleteBasic.vue?vue&type=script&lang=js"
export * from "./AutocompleteBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports